/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type EntityStatusEnum = 1 | 2 | 3 | 4 | 5 | 6;

export const EntityStatusEnum = {
    NUMBER_1: 1 as EntityStatusEnum,
    NUMBER_2: 2 as EntityStatusEnum,
    NUMBER_3: 3 as EntityStatusEnum,
    NUMBER_4: 4 as EntityStatusEnum,
    NUMBER_5: 5 as EntityStatusEnum,
    NUMBER_6: 6 as EntityStatusEnum
};
